/*
* Display license violation message
*/

<template>
  <div
    v-if="isLicenseMessage"
    class="broadcastMessage"
    :class="{ showing : isLicenseMessage, error : isLicense }"
  >
    <div
      v-if="isLicense"
      class="message"
    >
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import * as types from '../store/mutation-types'
import * as messageTypes from '../constants/message-types'

export default {
  name: 'LicenseMessage',
  computed: {
    ...mapState({
      licenseMessage: state => state.appFrame.licenseMessage,
    }),
    ...mapGetters(['getWindow']),
    isLicenseMessage: function () {
      return this.licenseMessage && this.licenseMessage.message.length
    },
    message: function () {
      return this.isLicenseMessage && this.licenseMessage.message
    },
    isLicense: function () {
      return this.isLicenseMessage && this.licenseMessage.type === messageTypes.LICENSE_MESSAGE
    },
  },
  beforeDestroy: function () {
    // don't keep message around on a context switch
    this.closeMessage()
  },
  methods: {
    closeMessage: function () {
      this.$store.commit(types.SET_LICENSE_MESSAGE, null)
    },
  },
}

</script>
